import React from "react";
import { FaTimes } from "react-icons/fa";

export function calculateImageCost(images = [], realLooks = false, creationOptionId = null) {
  try {
    const imagesArray = Array.isArray(images) ? images : [];
    const hasAnyImage = imagesArray.length > 0;
    const hasMask = imagesArray.some(img => !!(img && img.maskBlob));

    // Special pricing for remove_background
    if (creationOptionId === 'remove_background') return 6.30;

    if (hasAnyImage && hasMask) return 28.40;
    if (hasAnyImage && !hasMask && !!realLooks) return 25.2;
    if (hasAnyImage && !hasMask && !realLooks) return 12.30;
    return 12.30;
  } catch (_) {
    return 12.30;
  }
}

export function CostHelpModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onClose}></div>
      <div className="relative w-full sm:w-auto max-w-sm sm:max-w-md mx-2 sm:mx-0 mb-2 sm:mb-0 rounded-lg border border-white/10 bg-[#111] text-gray-200 overflow-hidden">
        <div className="flex items-center justify-between px-3 py-2 border-b border-white/10">
          <div className="text-xs sm:text-sm font-semibold">How cost is calculated</div>
          <button type="button" onClick={onClose} className="p-1 text-gray-400 hover:text-white" aria-label="Close">
            <FaTimes className="w-3.5 h-3.5" />
          </button>
        </div>
        <div className="p-3 text-[11px] sm:text-xs space-y-2">
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="text-gray-400">
                  <th className="py-1 pr-2 font-medium border-b border-white/10">Option</th>
                  <th className="py-1 pl-2 font-medium border-b border-white/10">Total</th>
                  <th className="py-1 pl-2 font-medium border-b border-white/10">Breakdown</th>
                  <th className="py-1 pl-2 font-medium border-b border-white/10">Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="py-1 pr-2 text-gray-400" colSpan={4}>Image generation (choose one)</td>
                </tr>
                <tr>
                  <td className="py-1 pr-2">Standard Image generation</td>
                  <td className="py-1 pl-2 text-gray-400">₹12.30</td>
                  <td className="py-1 pl-2 text-gray-400">Base</td>
                  <td className="py-1 pl-2 text-gray-400">Default</td>
                </tr>
                <tr>
                  <td className="py-1 pr-2">UGC/ Non AI Realistic Looks</td>
                  <td className="py-1 pl-2 text-gray-400">₹25.20</td>
                  <td className="py-1 pl-2 text-gray-400">₹12.30 base + ₹12.90 add-on</td>
                  <td className="py-1 pl-2 text-gray-400">Additional cost on Standard Image generation</td>
                </tr>
                <tr>
                  <td className="py-1 pr-2">Masking To Protect Details</td>
                  <td className="py-1 pl-2 text-gray-400">₹28.40</td>
                  <td className="py-1 pl-2 text-gray-400">₹12.30 base + ₹16.10 add-on</td>
                  <td className="py-1 pl-2 text-gray-400">Additional cost on Standard Image generation</td>
                </tr>
                <tr>
                  <td className="py-1 pr-2 text-gray-400" colSpan={4}>Standalone services</td>
                </tr>
                <tr>
                  <td className="py-1 pr-2">Remove background</td>
                  <td className="py-1 pl-2 text-gray-400">₹6.30</td>
                  <td className="py-1 pl-2 text-gray-400">—</td>
                  <td className="py-1 pl-2 text-gray-400">Standalone; not combined with generation</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="pt-1 text-[10px] text-gray-500">All prices are per image. Only one image-generation option applies at a time. Prices may vary by model or settings.</div>
        </div>
      </div>
    </div>
  );
} 